if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false,
        pauseOnHover : false
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 1000,
        fade: true,
        accessibility: false
    });

    $('.accordion-slide').slick({
        arrows: false,
        dots: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        accessibility: false,
        swipe: false
    });

    $('.reviews-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        accessibility: false
    });

    $('.slider-info-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        accessibility: false
    });
    $('.gallery-slides').slick({
        nextArrow:'#galNext',
        prevArrow:'#galPrev',
        fade:true,
        asNavFor: '.gallery-slides'
    });

    $('.awards-slider').slick({
        accessibility: true,
        arrows: true,
        slidesToShow: 2,        
        responsive: [
            {
                breakpoint: 768, 
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false
                }
            }
        ]
    });

    //Play Video
    $('.btn-play').click(function(){
        $('#VideoWedding').trigger('play');
        setTimeout(function(){
            $('.fancybox-close').click(function(){
                $('#VideoWedding').trigger('pause');
            });
        }, 1000);
    });



    //Menu Accordion
    $(".acc-btn").click(function(e){
        e.preventDefault();
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).next().slideToggle();
        } else {
            $(this).parent().siblings().children('.acc-btn').removeClass("active");
            $(this).parent().siblings().children(".tab-content").slideUp();
            $(this).addClass("active");
            $(this).next().slideToggle();
        }
    });

    //FAQ

    setTimeout(function(){
        $('.tab-label').each(function(){
            let thisHeightTap = $(this).height() + 40;
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeightTap + 'px'},200);
            if($(this).hasClass('open')){
                $(this).parent().animate({height: thisHeight + 'px'},400);
            }
        });
    }, 400);

    $('.tab-label').click(function(){
        let currentclick = $(this);
        let thisHeightTap = $(this).height() + 40;

        let slideIndex = $(this).data('artwork');
        $(".accordion-slide").slick('slickGoTo', parseInt(slideIndex));

        if(!currentclick.hasClass('open')){
            $('.tab-label').each(function(){
                if($(this) !== currentclick ){
                    if($(this).hasClass('open')){
                        let thisHeight = $(this).height() + 40;
                        $(this).removeClass('open');
                        $(this).parent().animate({height: thisHeight + 'px'},400);
                    }
                }
            });
            currentclick.addClass('open');
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeight + 'px'},400);
        } else {
            currentclick.removeClass('open');
            currentclick.parent().animate({height: thisHeightTap + 'px'},400);
        }
    });

    //Rooms
    function loadRoomsbyTag(container, selectVal){
        fetch(`${site_url}ajax/functions.php?operation=getRoomsByTag&rooms_tag=`+selectVal,{method: "GET"})
            .then((resp) => resp.json()) // Transform the data into json
            .then((data) => {
                container.innerHTML = data.html; //set data response via fetch in the container
            }).then((data) => {
            $('.images-slides').slick({
                autoplay:true,
                autoplaySpeed: 4000,
                speed: 500,
                fade: true,
                accessibility:false
            });
        });
    }

    const rooms_container = document.querySelector('.rooms-container');

    if (document.getElementsByClassName('menu-rooms').length >= 1) {
        loadRoomsbyTag(rooms_container,'all');
    }

    const special_links = document.querySelectorAll('.rooms-nav a');
    const specials_lengt = special_links.length;
    for(let i = 0; i < specials_lengt; i++){
        special_links[i].addEventListener('click', function(){
            const this_tag = this.dataset.tag;
            for(let l = 0; l < specials_lengt; l++){
                special_links[l].classList.remove('active');
            }
            this.classList.add('active');
            loadRoomsbyTag(rooms_container,this_tag);
        })
    }


    const special_selec = document.querySelectorAll('#rooms-nav');
    const special_lengt = special_selec.length;
    for(let i = 0; i < special_lengt; i++){
        special_selec[i].addEventListener('change', function(){
            const this_tag = this.value;
            loadRoomsbyTag(rooms_container,this_tag);
        })
    }


})();


let elementsGallery = []
function nextImage(){
    elementsGallery = []
    let totalImages = document.querySelectorAll('#carousel-id > div');
    for (let i = 0; i < totalImages.length; i++) {
        elementsGallery.push(document.querySelector(`.gallery-${i + 1}`))
    }
    let deleted = elementsGallery.shift()
    for (let e = 0; e < totalImages.length - 1; e++) {
        elementsGallery[e].className = `gallery-${e + 1}`
    }
    deleted.className = `gallery-${totalImages.length}`
    elementsGallery.push(deleted)
    for (let a = 0; a < elementsGallery.length; a++) {
        const element = elementsGallery[a];
        document.querySelectorAll('#carousel-id')[0].appendChild(element)
    }
}


function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 280;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}